module.exports = __webpack_public_path__ + "static/media/WELCOME-1.223b23ce.png";